export default async function({ $config, redirect }) {
  if ($config.UNDER_MAINTENANCE == true) {
    redirect("/under-maintenance");
  }
}
